import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { loadModules } from 'esri-loader';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class FclService {

  private fcl = new BehaviorSubject<any>(null);
  public fcl$ = this.fcl.asObservable();

  constructor() { }


  async loadFlareClusterLayer() {
    // changes the version of the underlying ArcGIS API for JavaScript
    // setDefaultOptions({ version: '4.20' })

    const options = {
      dojoConfig: {
        async: true,
        packages: [
          { name: 'fcl', location: environment.fclPath }
        ]
      }
    };

    loadModules(['fcl/FlareClusterLayer_v4', 'esri/symbols/SimpleMarkerSymbol', 'esri/tasks/PrintTask',], options)
      .then(([FlareClusterLayer, SimpleMarkerSymbol]) => {
        this.fcl.next(FlareClusterLayer);
      })
      .catch(err => {
        console.error('Error loading fcl:', err);
      });
  }
}
